import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Store } from '@ngxs/store';
import { AuthState } from './state/auth/auth.state';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "./auth.service";
import * as i3 from "@ngxs/store";
var AuthGuard = /** @class */ (function () {
    function AuthGuard(router, authService, store) {
        this.router = router;
        this.authService = authService;
        this.store = store;
    }
    AuthGuard.prototype.canActivate = function (next, state) {
        var _this = this;
        var isLoggedIn = this.store.selectSnapshot(AuthState.getLoggedIn);
        if (isLoggedIn) {
            return isLoggedIn;
        }
        // isLoggedIn route return a 401 forbidden when not logged in.
        // We'd expect it to a return 200 with a boolean body, but instead we're using the AJAX
        // library error handler to detect when the user isn't logged in.
        return this.authService.isLoggedIn().toPromise()
            .then(function (value) {
            if (value.signed_in) {
                return true;
            }
            else {
                _this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                return false;
            }
        });
    };
    AuthGuard.ngInjectableDef = i0.defineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(i0.inject(i1.Router), i0.inject(i2.AuthService), i0.inject(i3.Store)); }, token: AuthGuard, providedIn: "root" });
    return AuthGuard;
}());
export { AuthGuard };
